export default __webpack_public_path__ + "static/media/DAIF_Infra_Clean.225bd6e0.jpg";